// Chakra imports
import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
// Custom components
import BarChart from "components/charts/BarChart";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  barChartDataConsumption,
  barChartOptionsConsumption,
} from "variables/charts";
import { MdBarChart } from "react-icons/md";

export default function WeeklyRevenue(props) {
  const { data, ...rest } = props;
  const { t } = useTranslation();

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const iconColor = useColorModeValue("brand.500", "white");
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );
  return (
    <Card align='center' direction='column' w='100%' {...rest}>
      <Flex align='center' w='100%' px='15px' py='10px'>
        <Text
          me='auto'
          color={textColor}
          fontSize='xl'
          fontWeight='700'
          lineHeight='100%'>
          {t("Token Usage")}
        </Text>
        <Button
          align='center'
          justifyContent='center'
          bg={bgButton}
          _hover={bgHover}
          _focus={bgFocus}
          _active={bgFocus}
          w='37px'
          h='37px'
          lineHeight='100%'
          borderRadius='10px'
          {...rest}>
          <Icon as={MdBarChart} color={iconColor} w='24px' h='24px' />
        </Button>
      </Flex>

      <Box h='240px' mt='auto'>
        <BarChart
          chartData={transformData(data)}
          chartOptions={barChartOptionsConsumption}
        />
      </Box>
    </Card>
  );

  // Transform data
  function transformData(sampleArray) {
    if (!Array.isArray(sampleArray) || sampleArray.length === 0) {
      return [
        {
          name: t("Usage"),
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ];
    }
    
    const daysOrder = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const usageByDay = {};
    
    daysOrder.forEach(day => {
      usageByDay[day] = 0;
    });
    
    sampleArray.forEach(item => {
      const day = item.day?.toLowerCase() || 'sun';
      if (usageByDay.hasOwnProperty(day)) {
        usageByDay[day] += Number(item.usage || item.count || 0);
      }
    });
    
    const responseSample = [
      {
        name: t("Token Usage"),
        data: daysOrder.map(day => usageByDay[day]),
      },
    ];
    return responseSample;
  }
}
